import React from 'react';
import '../Style/Profile.css';
import rin from '../img/rin_icon.png';

export function Profile() {
  return (
    <div className="profile-container">
      <img src={rin} alt="rin0700" className="profile-image" />
      <div className="profile-info">
        <div className="profile-education">
          <p>
            新潟コンピュータ専門学校
            <br />
            情報システム科 応用システムコース 卒
          </p>
          <p>
            Mail:&nbsp;&nbsp;&nbsp;&nbsp;komamuraryuichi@gmail.com
            <br />
            X: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="https://x.com/rin_0700">@rin_0700</a>
          </p>
        </div>
        <p className="custom-underline"></p>
        <div className="center">
          <p>Portfolio / Creator</p>
          <h2 className="profile-title">rin0700</h2>
        </div>
        <h2>好きな言語・フレームワーク: Swift, SwiftUI, React</h2>
        <p className="tight-spacing">
          高校時代から iOS に興味を持ち、専門学生時代に Swift / SwiftUI
          を学びました。
          <br />
          豊富なライブラリとフレームワークがある開発しやすさに魅力を感じています。
        </p>
        <h2>趣味: メタバース</h2>
        <p className="tight-spacing">
          メタバースを通じて多くの方と出会い、さまざまな技術を学びました。
          <br />
          現在はアバター、衣装制作、テスター、商品のページ画像制作にも関わっています。
        </p>
      </div>
    </div>
  );
}

export default Profile;
